const SPECIAL_DIRECTORIES = ['emoji', 'editor', 'media-services', 'hipchat', 'bitbucket', 'jira'];

/**
 * Updates migration icon imports, to new icons or legacy icons.
 */
export const updateImports = (sourceCode: string, to: 'legacy' | 'new') => {
	if (to === 'new') {
		return sourceCode.replace(
			/import\s+(.*)\s+from\s+'@atlaskit\/icon\/(core|utility)\/migration\/([^']+?)(?:--[^']+)?';/gm,
			"import $1 from '@atlaskit/icon/$2/$3';",
		);
	} else {
		// Removes '/migration' and migration paths from icon imports, to transform them to old icons
		return sourceCode.replace(
			/import\s+(.*)\s+from\s+'@atlaskit\/icon\/(?:core|utility)\/migration\/([^']+?)(?:--([^']+))?';/gm,
			(_: string, importName: string, newIcon: string, oldIcon: string | undefined): string => {
				if (oldIcon) {
					const specialDir = SPECIAL_DIRECTORIES.find((dir) => oldIcon.startsWith(dir));
					if (specialDir) {
						const rest = oldIcon.slice(specialDir.length + 1); // +1 to remove the hyphen

						return `import ${importName} from '@atlaskit/icon/glyph/${specialDir}/${rest}';`;
					}
				}
				return `import ${importName} from '@atlaskit/icon/glyph/${oldIcon ?? newIcon}';`;
			},
		);
	}
};
